import useAuthStore from '@/stores/auth'

/**
 * The signed-in user's bearer token header, or nothing when signed out. Its own
 * module rather than part of `./middleware`, which the auth store's own import
 * graph reaches — importing that from outside the generated client cycles.
 */
export function bearerAuthHeaders(): Record<string, string> {
  const { accessToken } = useAuthStore()
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
}
